import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { ApiCollectionsService } from '../../../../services/collections/api/api-collections.service';
import { AlertsService } from '../../../../services/alerts.service';
import { CollectionLight } from '../../../../models/collections/collection-light.model';
import { CollectionPeriod } from '../../../../models/collections/collection-period.model';

@Component({
  selector: 'app-collection-period-edit-modal',
  templateUrl: './collection-period-edit-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, FormsModule]
})
export class CollectionPeriodEditModalComponent {

  @ViewChild('modal') modal!: ModalDirective;

  isLoading: boolean = false;
  collectionPeriodId: number = 0;
  name: string = '';
  collectionId: number | null = null;
  startDate: string = '';
  endDate: string = '';
  collections: CollectionLight[] = [];

  private callbackSaved?: () => void;

  constructor(private apiCollectionsService: ApiCollectionsService, private alertsService: AlertsService) {}

  show(period: CollectionPeriod, callbackSaved?: () => void): void {
    this.callbackSaved = callbackSaved;
    this.collections = [];
    this.apiCollectionsService.getAllCollections().then(
      response => { this.collections = response.results; },
      error => { this.alertsService.displayAlertError('Error loading collections : ' + error); }
    );
    this.collectionPeriodId = period.collectionPeriodId;
    this.name = period.name;
    this.collectionId = period.collectionId;
    this.startDate = period.startDateTimestamp ? this.timestampToDateString(period.startDateTimestamp) : '';
    this.endDate = period.endDateTimestamp ? this.timestampToDateString(period.endDateTimestamp) : '';
    this.isLoading = false;
    this.modal.show();
  }

  save(): void {
    this.isLoading = true;
    const startTimestamp = this.startDate ? Math.floor(new Date(this.startDate + 'Z').getTime() / 1000) : 0;
    const endTimestamp = this.endDate ? Math.floor(new Date(this.endDate + 'Z').getTime() / 1000) : 0;
    this.apiCollectionsService.editCollectionPeriod(this.collectionPeriodId, this.collectionId, this.name, startTimestamp, endTimestamp).then(
      () => {
        this.isLoading = false;
        this.modal.hide();
        this.alertsService.displayAlertSuccess('Period updated !');
        if (this.callbackSaved) { this.callbackSaved(); }
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error updating period : ' + error);
      }
    );
  }

  private timestampToDateString(timestamp: number): string {
    const d = new Date(timestamp * 1000);
    const month = (d.getUTCMonth() + 1).toString().padStart(2, '0');
    const day = d.getUTCDate().toString().padStart(2, '0');
    const hours = d.getUTCHours().toString().padStart(2, '0');
    const minutes = d.getUTCMinutes().toString().padStart(2, '0');
    return `${d.getUTCFullYear()}-${month}-${day}T${hours}:${minutes}`;
  }
}
